<section class="task-config__ondate-wrapper">
    <mat-form-field appearance="fill">
        <mat-label>{{ props.label || 'Date' }}</mat-label>
        <mat-select [formControl]="onDateModeControl">
            @for (preset of presets; track preset) {
                <mat-option [value]="preset">{{ preset.label }}</mat-option>
            }
        </mat-select>
        @if (!!props.description) {
            <mat-hint>{{ props.description }}</mat-hint>
        }
    </mat-form-field>

    @if (calendarDateMode) {
        <mat-form-field appearance="fill">
            <mat-label>Calendar date</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="calendarDateControl" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    }

    @if (customMode) {
        <mat-form-field appearance="fill">
            <mat-label>Custom date</mat-label>
            <input matInput [formControl]="customControl" placeholder="e.g. {{ customModeInitialValue }}" />
            <mat-hint>Define a custom relative date</mat-hint>
            @if (customControl.hasError('required')) {
                <mat-error>You must provide a value</mat-error>
            }
            @if (customControl.hasError('pattern')) {
                <mat-error>{{ patternErrorMessage }}</mat-error>
            }
        </mat-form-field>
    }
</section>
